import { arrowProfileIcon, userIcon } from "assets/images";
import { Avatar, Box, Button, Typography } from "@mui/material";
import { connect } from "react-redux";
import { getUserSelector } from "store/auth/selector";
import { AuthState } from "store/rootReducer";
import { ILoginResponse } from "utils/interfaces/login";

export type CustomProps = {
  profileOpen: boolean;
  handleProfileClick: any;
};

export type UserProfileSectionProps = {
  user: ILoginResponse;
} & CustomProps;

const UserProfileSection = ({ user, ...props }: UserProfileSectionProps) => {
  return (
    <>
      <Button
        id="profile-button"
        aria-controls={props.profileOpen ? "profile-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={props.profileOpen ? "true" : undefined}
        onClick={props.handleProfileClick}
        className="btn-profile"
        disableElevation
      >
        <Avatar src={userIcon} alt="profile" />
        <Box className="profile-info">
          <Box>
            <Typography variant="h5">
              {user?.firstName} {user?.lastName}
            </Typography>
            <Typography variant="h6">{user?.roleName?.toString()}</Typography>
          </Box>
          <img src={arrowProfileIcon} alt="arrow" />
        </Box>
      </Button>
    </>
  );
};

const mapStateToProps = (state: AuthState) => {
  return {
    user: getUserSelector(state),
  };
};

export default connect(mapStateToProps)(UserProfileSection);
